import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function B2BHero() {
  return <section className="relative bg-museum-gray overflow-hidden" data-id="element-38">
      {/* Hero Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28" data-id="element-39">
        <div className="text-center max-w-4xl mx-auto" data-id="element-40">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-41">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-museum-black leading-[1.1] tracking-tight mb-6" data-id="element-42">
              Manufacturers of short-run, custom products for the{' '}
              <span className="text-museum-blue" data-id="element-43">Museum, Gift & Souvenir</span>{' '}
              Retail markets
            </h1>

            <p className="text-lg md:text-xl text-museum-subtle mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-44">
              Museums | Historical Societies | Libraries | Botanical Gardens |
              Tourist Attractions | National Parks
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-45">
              <a href="#" className="inline-flex items-center justify-center bg-museum-blue text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-museum-dark transition-colors shadow-lg shadow-museum-blue/25 group" data-id="element-46">
                Explore Products
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-47" />
              </a>
              <a href="#" className="inline-flex items-center justify-center bg-white text-museum-black px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-colors border border-gray-200" data-id="element-48">
                Request a Quote
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}